/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
import{WorkerHandle as e}from"../../../../core/workers/WorkerHandle.js";function r(e){return e instanceof HTMLImageElement||e instanceof HTMLCanvasElement}class s extends e{constructor(e){super("TextureCompressionWorker","compress",{compress:e=>[e.data]},e)}isCompressible(e){return r(e)}}export{s as TextureCompressionWorkerHandle,r as isCompressible};
